module.exports = __webpack_public_path__ + "img/图片6.38fd7a75.png";